import {http} from '../utils'
// 查询
const searchAction = (params) => {
  const url = `/market/management/resource/page`
  return http.post(url, params)
}
// 获取status列表
const getStatus = (type) => {
  const url = `/market/common/codeList/${type}`
  return http.post(url)
}
// 获取group列表
const getGroup = (params) => {
  const url = '/market/management/group/all'
  return http.post(url, params)
}
// 获取 详情
const getAction = (id) => {
  const url = `/market/management/resource/detail/${id}`
  return http.post(url)
}
// 获取 详情 表格
const getListAction = (params) => {
  const url = `/market/management/resource/detail/page`
  return http.post(url, params)
}
// 获取 详情 表格的表头
const getListHeaderAction = (id) => {
  const url = `/market/management/resource/user/config/${id}`
  return http.post(url)
}
// 新建
const addAction = (params) => {
  const url = `/market/management/resource/save`
  return http.post(url, params)
}
// 修改禁用启用
const statusAction = (params) => {
  const url = `/market/management/resource/changeStatus`
  return http.post(url, params)
}
// 删除
const deleteAction = (id) => {
  const url = `/market/management/resource/delete/${id}`
  return http.post(url)
}
const getReportConditions = () => {
  const url = `/api/v1/report/condition/types`
  return http.get(url)
}
const analysisReportSql = params => {
  const url = `/market/management/resource/analysis/sql`
  return http.post(url, params)
}
const importAction = params => {
  const url = `/market/management/resource/data/import`
  return http.post(url, params)
}
// 获取下拉
const inSearchAction = params => {
  const url = `/market/management/resource/detail/page/inSearch`
  return http.post(url, params)
}

export default {
  searchAction,
  getStatus,
  getGroup,
  getAction,
  getListAction,
  getListHeaderAction,
  addAction,
  statusAction,
  deleteAction,
  getReportConditions,
  analysisReportSql,
  importAction,
  inSearchAction
}
